// Custom Functions Related to Admin Panel
var server = window.location.hostname;

var canvas_url = location.protocol + "//"+window.location.hostname +"/" ;

var API_URL = canvas_url + "api/";
var ADMIN_URL = canvas_url + "admin/";
var ADMIN_API_URL = ADMIN_URL + "api/";
var guided_search_stuff = {active_filters: {}};
var cUrl = window.location;
var sPath = window.location.pathname;
var sPage = sPath.substring(sPath.lastIndexOf('/') + 1);
var emptc = 3;
var timeout_redirect = 3000; //redirect timeout after showing a success or error message

var azure_api = {id: 'ricebowl-web', secret: 'dA/VMy4MLSrNCRnes75/MSP42TTOO2wcnJQObG2V9AU='};
function validateEmail(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
}
function validatePhone(phone) {
    var min = 10;
    var max = 12;
    var digits_only = phone.replace(/[^0-9]/g, '');
    var a = (phone.match(/^(?=.*[0-9])[- +()0-9]+$/) != null && digits_only.toString().length >= min && digits_only.toString().length <= max);
    return a;
}
function validatePassword(password) {
    var min = 5;
    var max = -1;
    return (password.toString().length >= min && (max < 0 || password.toString().length <= max));
}

function GetUrlParms(name) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(window.location.href);
    if (results == null)
        return "";
    else
        return results[1];
}

function CheckResumeApplyJob() {
    var resume_id = $("#resume_id").val();
    if (resume_id == 'na')
    {
        $("#noresume-checkbox").fadeIn();
    } else
    {
        $("#noresume-checkbox").fadeOut();
    }
}

function ClickBanner(id) {
    $.post(canvas_url + "api/banner/click", {'id': id, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
    }, "json");
}

function FilterURL(string) {
    string = string.toLowerCase();
    string = string.replace(" ", "-");
    string = string.replace(".", "-");
    string = string.replace(/[&\/\\#,@+()$~%.'":*?<>{}]/g, '');
    string = string.replace(/ /g, '-');
    return string;
}

function SetLanguage(lang) {
    var current_url = cUrl.href;
    var newurl = current_url.split('#')[0];
    if (newurl.indexOf("/job/") != -1 || newurl.indexOf("/state/") != -1 || newurl.indexOf("/category/") != -1 || newurl.indexOf("/company/") != -1 || newurl.indexOf("/contact") != -1 || newurl.indexOf("/pricing") != -1 || newurl.indexOf("/aboutus") != -1 || newurl.indexOf("/terms-condition") != -1 || newurl.indexOf("/aboutus") != -1 || cUrl.pathname == '/' || cUrl.pathname == '/en/' || cUrl.pathname == '/zh/' || cUrl.pathname == '/en' || cUrl.pathname == '/zh')
    {
        if (newurl.indexOf("/en") != -1)
        {
            newurl = newurl.replace("/en", "/" + lang);
            var newurlss = newurl;
        } else if (newurl.indexOf("/zh") != -1)
        {
            newurl = newurl.replace("/zh", "/" + lang);
            var newurlss = newurl;
        } else
        {
            var old = canvas_url;
            newurl = newurl.replace("/zh", "");
            newurl = newurl.replace("/en", "");
            var new_url = old + lang + '/';
            var newurlss = newurl.replace(old, new_url);
            //console.log(cUrl.href);
            //console.log(newurl);
            //console.log(old);
            //console.log(new_url);
            //console.log(newurlss);
        }
    } else
    {
        var newurlss = newurl;
    }

    console.log(newurlss);
    $.post(canvas_url + "api/setlang", {'lang': lang, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {

        //location.reload();
        window.location = newurlss;
    }, "json");
    $(document).ajaxError(function (e, xhr, settings, exception) {
        if (xhr.status == 404) {
            alert("The page you are lookin for not found.");
        }
        if (xhr.status == 500) {
            alert("An error occured while processing your request, please try again later.");
        }

    });
}

function SetLanguageHome(lang)
{


    if ($(".btn").hasClass("disabled")) {
        return false;
    } else
    {
//$(".btn-"+lang).html('<img src="'+canvas_url+'image/loading.gif" style="width:22px;">');
        $(".btn-" + lang).button('loading');
        //$(".btn").addClass("disabled");
        $.post(canvas_url + "api/setlang", {'lang': lang, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {

            if (server != 'localhost')
                canvas_url = canvas_url.replace("http:", "https:");
            window.location = canvas_url + lang + '/';
            setTimeout(function () {
                $(".btn-" + lang).button('reset');
            }, 3000);
        }, "json");
    }
}

function OnKeyPressJobseekerLogin(e)
{
    if (window.event) {
        e = window.event;
    }
    if ((e.keyCode == 13))
    {

        $(".submit_jobseekerlogin").trigger("click");
    }
}

function OnKeyPressJobSearch(e)
{
    if (window.event) {
        e = window.event;
    }
    if ((e.keyCode == 13))
    {
        var search_keyword = $("#search_keyword").val();
        var search_location_2 = $('#search_location_2').val();
        $("#search_location").val('');
        $("#search_category").val('');
        $("#filter_job_type").val('');
        $("#search_type").val('');
        $("#search_salary").val('');
        $("#search_education").val('');
        var qPage = 'q=' + encodeURIComponent(search_keyword) + "&loc=" + encodeURIComponent(search_location_2);
        window.location.hash = qPage;
        localStorage.setItem('qPage', qPage);
        for (var member in guided_search_stuff.active_filters)
            delete guided_search_stuff.active_filters[member];
        $.SearchJob();
    }
}

function OnClickJobSearch(e) {
//reset current search values
    var search_keyword = $("#search_keyword").val();
    var search_location_2 = decodeURIComponent($('#search_location_2').val());
    $("#search_location").val('');
    $("#search_category").val('');
    $("#filter_job_type").val('');
    $("#search_type").val('');
    $("#search_salary").val('');
    $("#search_education").val('');
    var qPage = 'q=' + encodeURIComponent(search_keyword) + "&loc=" + encodeURIComponent(search_location_2);
    window.location.hash = qPage;
    localStorage.setItem('qPage', qPage);
    for (var member in guided_search_stuff.active_filters)
        delete guided_search_stuff.active_filters[member];
    //$.updateFilters();
    //$.setUpFilters({filters:[]});
    $.SearchJob();
}

function OnKeyPressBlogPostSearch(e) {
    if ((e.keyCode === 13)) {
        e.preventDefault();
        var search_keyword = $("#blog_search_keyword").val();
        if (search_keyword !== '') {
            search_keyword = search_keyword.replace(/ /g, '_');
            search_keyword = search_keyword.replace(/&/g, '%26');
            ga('send', 'event', 'blog search', 'search', search_keyword);
            window.location = canvas_url + 'search/' + search_keyword;
        } else {
            ga('send', 'event', 'blog search', 'reset');
            window.location = canvas_url;
        }
    }
}


function ShowStates(country)
{
    $(".states").each(function (index) {
        $(this).hide();
    });
    if (country === '0' || country === 'Other')
    {
        $("#Other-state").show();
    } else
    {
        $("#" + country + "-state").show();
    }
}

function Paging(listing_type, start_limit, page, total_records, limit) {
    var midNumbers = 3; //midNumbers number left right from the page , lets   1 2 3   4    1 2 3
    var pagging = new Array();
    pagging['pagging'] = "";
    pagging['t'] = "";
    pagging['sql'] = "";
    pagging['Start'] = "";
    pagging['Preveious'] = "";
    pagging['Mid'] = "";
    pagging['MidTemp'] = "";
    pagging['Next'] = "";
    pagging['End'] = "";
    if (listing_type === 'BlogPostListing') {
        txt_next = '';
        txt_previous = '';
    }

    if (total_records > 0)
    {
        var aNextImage = '' + txt_next + ' <i class="mdi mdi-chevron-right"></i>'; //Active next image
        var NextImage = '' + txt_next + ' <i class="mdi mdi-chevron-right"></i>';
        var aPrevImage = '<i class="mdi mdi-chevron-left"></i> ' + txt_previous + '';
        var PrevImage = '<i class="mdi mdi-chevron-left"></i> ' + txt_previous + '';
        limitvalue = (page - 1) * limit;
        numofpages = Math.ceil(total_records / limit);
        if (page === 0)
            page = 1;
        pagging['t'] = '<ul class="pagination">';
        if (page > 1)
        {
            pageprev = page - 1;
            pagging['Preveious'] += "<li onclick=\"LoadPaging('" + listing_type + "'," + pageprev + "); ga('send','event','Pagination','click'," + pageprev + ");\" style='cursor:pointer' aria-label='Previous'><a>" + aPrevImage + "</a></li>";
        } else
        {
            left_link = "&nbsp;";
            pagging['Preveious'] += '<li class="previous disable"><a href="">' + txt_previous + '</a></li>';
            if (txt_previous === '')
                pagging['Preveious'] = '';
        }


        pagging['pagging'] += '';
        for (i = 1; i <= numofpages; i++)
        {
            if (i > page - midNumbers && i < page + midNumbers)
            {

                if (page === i)
                {
                    pagging['MidTemp'] = '<li class="active"><a>' + (i + "") + '</a></li>';
                    pagging['Mid'] += pagging['MidTemp'];
                } else
                {
                    pagging['MidTemp'] = "<li onclick=\"LoadPaging('" + listing_type + "'," + i + "); ga('send','event','Pagination','click'," + i + ");\" style='cursor:pointer'><a>" + i + "</a></li>";
                    pagging['Mid'] += pagging['MidTemp'];
                }

            }
        }
        pagging['pagging'] += '';
        if (page < numofpages)
        {
            pagenext = (page + 1);
            pagging['Next'] += "<li onclick=\"LoadPaging('" + listing_type + "'," + pagenext + "); ga('send','event','Pagination','click'," + pagenext + ");\" style='cursor:pointer' aria-label='Next'><a>" + aNextImage + "</a></li>";
        } else
        {
            pagging['Next'] += '<li class="previous disable"><a href="">' + txt_next + '</a></li>';
            if (txt_next === '')
                pagging['Next'] = '';
        }

        pagging['pagging'] += pagging['t'];
        pagging['pagging'] += pagging['Preveious'];
        pagging['pagging'] += '' + pagging['Mid'] + '';
        pagging['pagging'] += pagging['Next'];
    }

    if (total_records < limit)
    {
//document.getElementById("Paging").style.display = "none";
    }

    return pagging['pagging'];
}

function LoadPaging(listing_type, page)
{
    if (listing_type === 'JobListing')
    {
        $("#page").val(page);
        $.getJobs(page);
    }

    if (listing_type === 'BlogPostListing')
    {
        $("#page").val(page);
        $.getBlogPosts(page);

        $.getBannerV3('weblite_desktop');
        $.getBannerV3('weblite_mobile');
    }

    var current_hash = window.location.hash; //filters and stuff
    var current_page = '?page=' + page;
    history.pushState('data', '', current_page + current_hash);
}

function notify(message, type) {
    /*$.growl({
     message: message
     },{
     element: 'body',
     type: type,
     allow_dismiss: false,
     label: 'Cancel',
     className: 'btn-xs btn-inverse',
     placement: {
     from: 'top',
     align: 'right'
     },
     delay: 250000,
     timer: 100000,
     animate: {
     enter: 'animated bounceIn',
     exit: 'animated bounceOut'
     },
     offset: {
     x: 20,
     y: 85
     }
     });*/
    console.log('$.growl has been deprecated. using $.notify instead');
    $.notify({message: message}, {type: type});
}
;
//smoothly scroll to an element
function go(to, offset, speed) {
    if (typeof to != 'undefined' && (to == '' || $(to).length > 0)) {
        if (typeof offset == 'undefined')
            offset = 0;
        if (typeof speed == 'undefined')
            speed = 0;
        if (to == '')
            to = 0;
        else
            to = $(to).offset().top - offset;
        if (to !== '') {
            $('body, html').animate({
                scrollTop: to
            }, speed);
        }
    } else {
        console.log('scroll error: "' + to + '" does not exist');
    }
}

function trackEvent(o) {
    var defaults = {
        '_token': $('meta[name="csrf-token"]').attr('content'),
        'event': '',
        'key': '',
        'value': ''
    }
    o = $.extend({}, defaults, o);
    $.post(canvas_url + "api/track-event", o, function (data) {}, "json");
}

// START OF DOCUMENT READY
$(document).ready(function () {
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.sort-input').length) {
// Hide the menus.
            $(".sort-dropdown").hide();
        }
    });

    /*
     ******************** Start Search Suggestion ********************
     */

    var suggestion_stuff = {};
    suggestion_stuff.caret = -1;
    suggestion_stuff.pressed_enter = false;
    suggestion_stuff.char_count = 0;
    suggestion_stuff.min_count = 3;
    $('#search_keyword').keyup(function (e) {

//pressing tab or shift
        if (e.keyCode == 9 || e.keyCode == 16) {
            $("#search-area-suggestion").hide();
        }

//pressing left or right
        else if (e.keyCode == 37 || e.keyCode == 39) {
//do nothing
        }

//pressing enter
        else if (e.keyCode == 13) {
            suggestion_stuff.pressed_enter = true;
            $("#search-bar").removeClass('active');
            $("#suggestion").hide();
            $('#search_keyword').blur();
            OnKeyPressJobSearch(e);
        }

//pressing up
        else if (e.keyCode == 38) {
            e.preventDefault();
            var ul = $('#suggestion ul').children();
            if (suggestion_stuff.caret > 0)
                suggestion_stuff.caret--;
            else
                suggestion_stuff.caret = ul.length - 1;
            ul.css('background-color', 'initial');
            $(ul[suggestion_stuff.caret]).css('background-color', '#eee');
            $('#search_keyword').val($(ul[suggestion_stuff.caret]).text().trim());
            return false;
        }

//pressing down
        else if (e.keyCode == 40) {
            e.preventDefault();
            var ul = $('#suggestion ul').children();
            if (suggestion_stuff.caret < (ul.length - 1))
                suggestion_stuff.caret++;
            else
                suggestion_stuff.caret = 0;
            ul.css('background-color', 'initial');
            $(ul[suggestion_stuff.caret]).css('background-color', '#eee');
            $('#search_keyword').val($(ul[suggestion_stuff.caret]).text().trim());
            return false;
        }

//pressing letters
        else {
            suggestion_stuff.pressed_enter = false;
            var suggestion = $("#suggestion");
            if ($('#search_keyword').val().length > 1) {
                $("#search-bar").addClass('active')
                $.ajax({
                    url: canvas_url + "api/job/suggest?param=" + $('#search_keyword').val(),
                    dataType: 'json',
                    success: function (data) {
                        if (suggestion_stuff.pressed_enter == false) {
                            var html = '<ul>';
                            for (var i = 0; i < data.job.length; i++) {
                                html += '<li class="suggestion-job" data-text="' + data.job[i].text + '"><a href="#"><i class="mdi mdi-briefcase"></i> ' + data.job[i].text + '</a></li>';
                                ///job/'+data.job[i].payload.jobId+'-'+data.job[i].text.replace(/ /g, '-')+'
                            }
                            for (var i = 0; i < data.company.length; i++) {
                                html += '<li><a href="/company/' + data.company[i].text.replace(/ /g, '-') + '"><i class="mdi mdi-city"></i> ' + data.company[i].text + '</a></li>';
                            }
                            html += '</ul>';
                            suggestion.html(html);
                            suggestion.show();
                        }
                    }
                });
            } else {
                suggestion_stuff.caret = -1;
                suggestion.hide();
                $("#search-bar").removeClass('active');
            }

            if ($('#search_keyword').val().length < 1) {
                suggestion.hide();
                suggestion_stuff.char_count = 0;
            }

        }
    });
    $('body').on('click', '.suggestion-job', function (e) {
        e.preventDefault();
        var suggestion = $("#suggestion");
        $('#search_keyword').val($(this).attr('data-text'));
        suggestion.hide();
        $("#search-bar").removeClass('active');
        $.SearchJob();
    });
    $(document).mouseup(function (e) {
        var suggestion = $("#suggestion");
        if (!suggestion.is(e.target) // if the target of the click isn't the suggestion...
                && suggestion.has(e.target).length === 0) // ... nor a descendant of the suggestion
        {
            suggestion_stuff.caret = -1;
            suggestion.hide();
            $("#search-bar").removeClass('active');
        }


    });
    /*
     ******************** End Search Suggestion ********************
     */

    /*
     ******************** Start Dynamic Suggestion ********************
     */
    var suggestion_stuff = {};
    suggestion_stuff.caret = -1;
    suggestion_stuff.pressed_enter = false;
    $('.suggestion-thing').keydown(function (e) {
//types: job, company, area, education
        var id = $(this).attr('id'); //company, job-title
        var type = $(this).attr('data-type'); //company, job-title
        if (type == undefined || type == '')
            type = 'all';
        var target = $(this).attr('data-target'); //string
        var suggestion = $("#" + target); //dom element
        var url = '';
        $('#' + target.replace('-suggestion', '-confirm')).val('no');
        if ($(this).val().length > 1) {
            $.ajax({
                url: "http://maukerja-search-app-prod.elasticbeanstalk.com/suggestions/" + type + "/find?text=" + $(this).val(),
                dataType: 'json',
                success: function (data) {
                    var html = '<ul data-target="' + target + '" data-field="#' + id + '">';
                    var icon = '';
                    if (type == 'job')
                        icon = 'mdi-briefcase';
                    else if (type == 'company')
                        icon = 'mdi-city';
                    else if (type == 'area')
                        icon = 'mdi-city';
                    else if (type == 'education')
                        icon = 'mdi-city';
                    for (var i = 0; i < data.length; i++) {
                        html += '<li class="dynamic-suggestion-job" data-text="' + data[i] + '"><a href="#"><i class="mdi ' + icon + '"></i> ' + data[i] + '</a></li>';
                    }

                    html += '</ul>';
                    suggestion.html(html);
                    suggestion.show();
                }
            });
        } else {
            suggestion.hide();
        }
    });
    $('body').on('click', '.dynamic-suggestion-job', function (e) {
        e.preventDefault();
        var field = $(this).parent().attr('data-field'); //string
        var target = $(this).parent().attr('data-target'); //string
        var suggestion = $("#" + target); //dom element
        $('#' + target.replace('-suggestion', '-confirm')).val('yes');
        $(field).val($(this).attr('data-text'));
        suggestion.hide();
    });
    $(document).mouseup(function (e) {
        var suggestion = $(".suggestion-thing-content");
        if (!suggestion.is(e.target) // if the target of the click isn't the suggestion...
                && suggestion.has(e.target).length === 0) // ... nor a descendant of the suggestion
        {
            suggestion.hide();
        }
    });
    /*
     ******************** End Dynamic Suggestion ********************
     */

    /*******************************************SEO BLOG CATEGORY Listing ********************************/
    $.getBlogCategories = function ()
    {
        var resultDiv = '';
        var jsonData = {
            'is_front': 'yes',
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "GET"
        };
        var request = $.ajax({
            url: API_URL + "admin/blogcategory",
            data: jsonData,
            type: 'GET',
            crossDomain: true,
            dataType: 'json',
            timeout: 3000
        });
        $('#spinner').show();
        request.done(function (data) {

            $('#spinner').hide();
            if (data.status == 'success')
            {
                var category = data.data;
                var current = category.length;
                for (var i = 0; i < current; i++)
                {
                    resultDiv += '<li style="padding:5px" ><a onclick="ga(\'send\',\'event\',\'categories\',\'view\',\'' + category[i].name + '\');" href="' + canvas_url + 'category/' + FilterURL((category[i].slug == '' ? category[i].name : category[i].slug)) + '" id="blogcategory-' + category[i].category_id + '" class="blogcategory">' + category[i].name + '</a></li>';
                }
                $("#blogcategory-list").html(resultDiv);
            }
        });
        request.fail(function (jqXHR, textStatus) {
            console.log("Problem getting categories - " + textStatus);
        });
    };

    /*******************************************SEO BLOG POST Listing ********************************/
    var countReload = 0;
    $.getBlogPosts = function (page)
    {
        var current_page = parseInt($("#page").val());
        if (current_page > 1)
        {
            page = current_page;
        }


        var category_id = $("#category_id").val();
        var tag = $("#tag").val();
        var search_keyword = $("#blog_search_keyword").val();
        var resultDiv = '';
        //var sort_by = 'post_id';//$("#user_sort").val();
        var sortBy = 2; //published_at
        var orderBy = 2; //DESC
        var limit = 10;
        var start_limit = (page - 1) * limit;
        start_limit = (start_limit < 0) ? 0 : start_limit;
        var jsonData = {
            category_id: category_id,
            tag: tag,
            'is_front': 'yes',
            keyword: search_keyword,
            sort_by: sortBy,
            order_by: orderBy,
            start: start_limit,
            noOfRecords: limit,
            post_status: 2,
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "GET"
        };
        var request = $.ajax({
            url: API_URL + "admin/blogpost/list",
            data: jsonData,
            type: 'GET',
            crossDomain: true,
            dataType: 'json',
            timeout: 10000
        });
        $('#skeleton').show();
        $('#posts').hide();
        request.done(function (data) {
            if (data.status == 'success')
            {
                var count = data.totalRecords;
                var post = data.data;
                var current = post.length;
                var joburl = '';
                for (var i = 0; i < current; i++)
                {
                    post[i].seo_link = post[i].seo_link.replace("/", "");
                    var updatedAt = post[i].updated_at;
                    if(updatedAt.includes("-0001"))
                    {
                        updatedAt = post[i].created_at;
                    }
                    joburl = canvas_url + '' + post[i].seo_link;
                    resultDiv += '<div class="blog-post-wrap" >\
						<div class="blog-post">\
						  <div class="bp-header"> <a onclick="ga(\'send\', \'event\', \'posts\', \'read\', \'' + post[i].seo_link + '\');" href="' + joburl + '"><div class="bp-pic"><img height="200px" width="380px" class="lazy" style="height: 100%;width: 100%;" data-src="' + canvas_url + 'data/blog/' + (post[i].cover_photo.indexOf('/') !== -1 ? 'images/' : '') + post[i].cover_photo + '"></div></a> <a href="' + joburl + '" class="bp-title">\
							<div>' + post[i].title + '</div>\
							</a> </div>\
						  <div class="bp-post"><div>' + post[i].summary + ' </div></div>\
						  <div class="bp-footer">\
						    <div class="left">\
                            <div class="a2a_kit a2a_kit_size_25 a2a_default_style" data-a2a-url="' + joburl + '" data-a2a-title="' + post[i].title + '">\
                                <a class="a2a_button_facebook"></a>\
                                <a class="a2a_button_facebook_messenger"></a>\
                                <a class="a2a_button_whatsapp"></a>\
                                <a class="a2a_button_wechat"></a>\
                                <a class="a2a_button_twitter"></a>\
                            </div>\
                            </div>\
							<div class="right">\
							  <p>'+ post[i].view_count + ' ' + localizedText.views + ' &middot; ' + updatedAt + '</p></div>\
                            <div class="clearfix"></div>\
						  </div>\
						</div>\
					  </div>';

                    //  desktop
                    if (i == 7) {
                        resultDiv += '<div id="ad-banner-center-rotation" class="blog-ad-banner-wrap"></div>';
                    }
                    // mobile
                    if (i == 7) {
                        resultDiv += '<div id="ad-banner-center-rotation-mobile" class="blog-ad-banner-wrap mobile"></div>';
                    }
                }

                $("#posts").html(resultDiv);
                $("#scripts").html('<script async src="//static.addtoany.com/menu/page.js"></script>');
                $("img.lazy").Lazy();
                $(".blogcategory").removeClass("active");
                if (category_id != '0')
                {
                    $("#blogcategory-" + category_id).addClass("active");
                }

                $(".paging-div").show();
                document.getElementById("Paging").innerHTML = Paging('BlogPostListing', start_limit, page, count, limit);
                $('#skeleton').hide();
                $('#posts').show();
            } else
            {
                $("#posts").html('<div style="text-align:center"><h2 class="text-red">No Post Found</h2></div>');
                $("#Paging").hide();
            }
        });
        request.fail(function (jqXHR, textStatus) {
            $('#posts').show();
            $("#posts").html('<div id="snackbar"><p>The connection has timed out.</p><p>We\'re trying to reconnect in <span id="countdown">3</span> second</p></div>');

            var timeleft = 3;
            if (countReload < 3) {
                var downloadTimer = setInterval(function(){
                    if(timeleft < 0){
                        countReload += 1;
                        $.getBlogPosts();
                        clearInterval(downloadTimer);
                    } else {
                        document.getElementById("countdown").innerHTML = timeleft;
                    }
                    timeleft -= 1;
                }, 1000);
            } else {
                $("#snackbar").html('<div>The connection has timed out. </div>');
            }

            var x = document.getElementById("snackbar");
            x.className = "show";

            $("#Paging").hide();
        });
    }
    /*******************************************SEO BLOG FEED TOUR ********************************/
    $.getBlogFeedTour = function ()
    {
        var resultDiv = '';
        var jsonData = {};
        var request = $.ajax({
            url: API_URL + "blogfeed-tour/list",
            data: jsonData,
            type: 'GET',
            crossDomain: true,
            dataType: 'json',
            timeout: 10000
        });
        request.done(function (data) {
            if (data.success) {
                var post = data.data;
                var current = post.length;
                var seoLink = "";
                if(current) {
                    $("#blogfeed-tour-main").show();
                    for (var i = 0; i < current; i++) {
                        post[i].seo_link = post[i].seo_link.replace("/", "");
                        seoLink = canvas_url + '' + post[i].seo_link;
                        resultDiv += '<div class="blogfeed-post">\
                            <div class="form-group-table" style="position: relative;">\
                                <div class="form-table top">\
                                    <div class="blogfeed-img" style="background-image: url('+ canvas_url + '/data/blog/' + (post[i].cover_photo.indexOf('/') !== -1 ? 'images/' : '') + post[i].cover_photo.replace('-big', '-medium') + ');"></div>\
                                </div>\
                                <div class="form-table active top">\
                                    <div class="blogfeed-title-wrap">\
                                    <a href="'+ seoLink +'" target="_blank" class="blogfeed-title">'+ post[i].title +'</a>\
                                    </div>\
                                    <div class="blogfeed-feed-wrap">\
                                    <p class="blogfeed-feed">'+ post[i].summary +'</p>\
                                    </div>\
                                    <div class="blogfeed-info">\
                                    <span class="blogfeed-date"><i class="mdi mdi-calendar-clock"></i>' + post[i].created_at + '</span>\
                                    </div>\
                                </div>\
                            </div>\
                        </div>';
                    }
                    $("#blogfeed-tour").html(resultDiv);
                } else {
                    $("#blogfeed-tour-main").hide();
                }
            }
        });
        request.fail(function (jqXHR, textStatus) {
            $("#blogfeed-tour-main").hide();
        });
    }
    ////////////////// FUNCTIONS FOR LEFT BAR SELECTION \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

    if ($('.dashboard').length > 0)
    {
        $("#nav-dashboard").addClass("active");
    }

    if ($('.blogpage').length > 0)
    {
        $.getBlogCategories();
        $.getBlogPosts(0);
        $.getBlogFeedTour();
        $.getJobRecommendation("trend", "", 3, "", "", "");
    }

    if ($('.blogdetailpage').length > 0)
    {
        $.getBlogCategories();
        $.getJobRecommendation("trend", "", 5, "", "", "");
    }

    if ($('.homepage').length > 0)
    {
        $(".job-counter").removeClass("hide");
        $(".main-header-wrap").removeClass("no-background");
        var query = location.href.split('#');
        if (typeof query[1] != 'undefined') // Hashes defined
        {
            var u = query[1].split("&");
            var v = '';
            for (var i = 0; i < u.length; i++)
            {
                v = u[i].split("=");
                if (v[0] == 'q')
                {
                    $("#search_keyword").val(v[1]);
                    $("#keywords").val(v[1]);
                }
                if (v[0] == 'cat')
                {
                    $("#search_category").val(v[1]);
                    $("#prefer_categories").val(v[1]);
                }
                if (v[0] == 'loc')
                {
                    $("#search_location").val(v[1]);
                    $("#prefer_locations").val(v[1]);
                }
                if (v[0] == 'sal')
                {
                    $(".filter_salary").each(function (index) {

                        if ($(this).attr("value") == v[1])
                        {
                            $(this).prop("checked", true);
                        }
                    });
                }
                if (v[0] == 'jtype')
                {
                    var jj = v[1].split(",");
                    var kk = 0;
                    for (var kk = 0; kk < jj.length; kk++)
                    {
                        $(".filter_job_type").each(function (index) {
                            if ($(this).attr("value") == jj[kk])
                            {
                                $(this).prop("checked", true);
                            }
                        });
                    }
                }

            }
            $("#filter_sorting").removeClass("hide");
            $.getJobs(0);
            $.getFeaturedJobs(0);
        } else
        {
            localStorage.setItem('qPage', null);
            $.getJobs(0);
            $.getFeaturedJobs(0);
        }

        //$.getCategoriesDropdown();
        //$.getLocationsDropdown();

        //$.getPreferCategoriesDropdown();
        //$.getPreferLocationsDropdown();

        $(".topnav-home").addClass("active");
        //$("#nav-dashboard").addClass("active");
    }

    if ($('.loginsignup').length > 0)
    {
        $(".loginsignup").addClass('background-rice');
        $(".topnav-login").addClass("active");
    }
    if ($('.pricing').length > 0)
    {
        $(".topnav-pricing").addClass("active");
    }
    if ($('.contactpage').length > 0)
    {
        $(".topnav-contact").addClass("active");
    }

    if ($('.changepassword').length > 0)
    {
        $(".topnav-profile").addClass("active");
        $(".topnav-profile").removeClass("close");
        $(".topnav-profile").addClass("open");
        $("#nav-changepassword").addClass("active");
    }

    $('#change-contact').click(function (e) {
        e.preventDefault();
        //prepare stuff
        $('#change-contact-save').attr('data-field', $(this).attr('data-field'));
        var placeholder;
        if ($(this).attr('data-field').toLowerCase() === 'email')
            placeholder = txt_your_email;
        else
            placeholder = txt_enter_phone;
        $('#change-contact-value').attr('placeholder', placeholder);
        $('#change-contact-value').val($(this).attr('data-' + $(this).attr('data-field').toLowerCase()));
        var label;
        if ($(this).attr('data-field').toLowerCase() === 'email')
            label = txt_email.toLowerCase();
        else
            label = txt_phone.toLowerCase();
        $('#change-contact-label').text(label);
        $('#change-contact-value').removeAttr("disabled");
        //show everything
        //$('#change-contact-bg').fadeIn('fast');
        //$('#change-contact-box').fadeIn('fast');
        $('#change-contact-modal').modal('show');
    });
    $('#change-contact-save').click(function (e) {
        //change email or phone number directly in the verification warning message in job seeker profile page
        e.preventDefault();
        var _this = $(this);
        var $btn = $(this);
        change_contact_data = {};
        change_contact_data._token = $('meta[name="csrf-token"]').attr('content');
        change_contact_data._method = 'POST';
        if ($(this).attr('data-field').toLowerCase() === 'email') {
            change_contact_data.email = $('#change-contact-value').val();
            if (change_contact_data.email === '') {
                $.notify(notify_msg.required.email);
                return false;
            } else if (!validateEmail(change_contact_data.email)) {
                $.notify(txt_correct_email_address);
                return false;
            }
        } else if ($(this).attr('data-field').toLowerCase() === 'phone') {
            change_contact_data.contact_number = $('#change-contact-value').val();
            if (change_contact_data.contact_number === '') {
                $.notify(txt_enter_phone_number);
                return false;
            } else if (!validatePhone(change_contact_data.contact_number)) {
                $.notify(notify_msg.invalid.phone);
                return false;
            }
        }

        //$('#change-contact-msg').hide();
        //$('#change-contact-msg').attr('class', '');
        //$("#change-contact-save").addClass("disabled");
        //$('#change-contact-value').attr("disabled", "disabled");
        //$('#change-contact-loading').show();
        $btn.button('loading');
        $.post(canvas_url + "api/jobseeker/field", change_contact_data, function (data) {
            if (data.status === 'success') {
                //$('#change-contact-msg').addClass('success');
                setTimeout(function () {
                    window.location.reload();
                }, timeout_redirect);
                $.notify(data.msg, {type: 'success'});
                $('#change-contact-modal').modal('hide');
                $btn.button('reset');
            } else {
                //$('#change-contact-msg').addClass('error');
                //$('#change-contact-value').removeAttr("disabled");
                //$("#change-contact-save").removeClass("disabled");
                $.notify({message: data.msg}, {type: "danger"});
                $btn.button('reset');
            }
            $btn.button('reset');
            //$('#change-contact-loading').hide();
            //$('#change-contact-msg').html(data.msg);
            //$('#change-contact-msg').show();
        }, "json");
    });
    /*
     **************************************** Start Guided Search (filters) ****************************************
     */

    $(document).on('click', '.remove-filter', function () {
        var parent = $(this).attr('data-parent');
        //reset current search values (to refresh available filters)
        if (guided_search_stuff.active_filters['parent_' + parent].type === 'regions')
            $("#search_location").val('');
        if (guided_search_stuff.active_filters['parent_' + parent].type === 'education')
            $("#search_education").val('');
        if (guided_search_stuff.active_filters['parent_' + parent].type === 'jobType')
            $("#search_type").val('');
        if (guided_search_stuff.active_filters['parent_' + parent].type === 'salary')
            $("#search_salary").val('');
        //guided_search_stuff.active_filters.splice($.inArray(parent, guided_search_stuff.active_filters), 1);
        delete guided_search_stuff.active_filters['parent_' + parent];
        //update stuff
        if ($(this).parent().parent().parent().attr('id') === 'active-filters') {
            //if removing from the main content, instead of modal
            var parent = $(this).attr('data-parent');
            var child = $(this).attr('data-child');
            var element_in_modal = $($($('.available-filters')[parent]).children()[child]);
            //must update modal as well
            //element_in_modal.removeAttr('data-index');
            element_in_modal.removeClass('active');
            element_in_modal.removeClass('remove-filter');
            element_in_modal.addClass('add-filter');
            $(this).parent().remove();
            guidedSearch();
        } else {
            //removing from modal
            //$(this).removeAttr('data-index');
            $(this).removeClass('active');
            $(this).removeClass('remove-filter');
            $(this).addClass('add-filter');
        }

        if ($('.search-filter > .filter-tag').children(':visible').length === 0) {
            $('.search-filter > .filter-tag').parent().hide();
            /*if($('#search_keyword').val() == '*')
             $('#search_keyword').val('');*/
        }

        $.updateFilters();
    });
    $(document).on('click', '.add-filter', function () {
        var $this = $(this);
        var label = $this.find('span.filter-label').text();
        var count = $this.find('span.filter-count').text().replace(/[\(\)]/g, '');
        var parent = $this.attr('data-parent');
        var child = $this.attr('data-child');
        var type = $this.attr('data-type');
        //update search values (to refresh available filters)
        if (type === 'regions')
            $("#search_location").val(label);
        else if (type === 'education')
            $("#search_education").val(label);
        else if (type === 'jobType')
            $("#search_type").val(label);
        else if (type === 'salary')
            $("#search_salary").val(label);
        //only one filter per category - let's reset the buffer and dom elements
        if ($this.parent().find('.active').length > 0) {
            //var ind = $($this.parent().find('.active')[0]).attr('data-index');
            //guided_search_stuff.active_filters.splice($.inArray(ind, guided_search_stuff.active_filters), 1);
            //guided_search_stuff.active_filters.splice($.inArray(parent, guided_search_stuff.active_filters), 1);
            //$this.parent().find('.active').removeAttr('data-index');
            $this.parent().find('.active').removeClass('remove-filter');
            $this.parent().find('.active').addClass('add-filter');
            $this.parent().find('.active').removeClass('active');
        }
        //mark the correct filter
        guided_search_stuff.active_filters['parent_' + parent] = {label: label, count: count, parent: parent, child: child, type: type};
        //console.log(guided_search_stuff.active_filters);
        //guided_search_stuff.active_filters.push({label:label, count:count, parent:parent, child:child});
        //$this.attr('data-index', guided_search_stuff.active_filters.length - 1);
        $this.addClass('remove-filter');
        $this.removeClass('add-filter');
        $this.addClass('active');
        $.updateFilters();
        /*
         * in case something goes wrong, we can uncomment this to disable the new filters
         */
        //$('#update-filters').trigger('click');
    });
    $(document).on('click', '#clear-filters', function () {
        $.clearFilters();
    });

    $('#update-filters').click(function () {
        var tagwrap = $(".search-filter");
        var tagcontent = $(".search-filter > .filter-tag");
        $($('#active-filters').find('ul')[0]).html('');
        tagwrap.show();
        //trigger the actual search
        guidedSearch();
    });
    var guidedSearch = function () {
        //reset everything
        var search_keyword = $("#search_keyword").val();
        $("#search_keyword").val('');
        $("#search_location").val('');
        var search_location_2 = $('#search_location_2').val();
        $("#search_education").val('');
        $("#search_salary").val('');
        //apply the correct filters
        $.each(guided_search_stuff.active_filters, function (k, v) {
            //set values for the search
            if (v.type === 'regions')
                $("#search_location_2").val(v.label);
            else if (v.type === 'education')
                $("#search_education").val(v.label);
            else if (v.type === 'jobType')
                $("#search_type").val(v.label);
            else if (v.type === 'salary')
                $("#search_salary").val(v.label);
            var qPage = 'q=' + encodeURIComponent($("#search_keyword").val())
            if($("#search_location_2").val() !== '')
            {
                qPage = qPage + "&loc=" + encodeURIComponent($("#search_location_2").val());
            }

            search_keyword = search_keyword.replace(/ /g, '_');
            search_keyword = search_keyword.replace(/&/g, '%26');
            //var qPage = 'q='+$("#search_keyword")+"&cat=&loc="+$("#search_location")+"&sal="+$("#search_salary")+
            //"&jtype="+$("#search_type")+"&edu="+$("#search_education");

            window.location = 'https://www.ricebowl.my/content/search/job' + '?' + qPage;
            if (server === 'blog.maukerja.my')
            {
                window.location = 'https://www.maukerja.my/content/search/job' + '?' + qPage;
            } else if (server === 'blog.ajobthing.com')
            {
                window.location = 'https://www.ajobthing.com/' + '#' + qPage;
            } else if (server === 'blog.maukerja.id')
            {
                window.location = 'https://www.maukerja.id/' + '#' + qPage;
            }
            localStorage.setItem('qPage', qPage);
            //window.location.href = canvas_url.replace('blog.', 'www.') + qPage;
            //window.location.hash = 'ricebowl.my' + '#' + qPage;
            //localStorage.setItem('qPage', qPage);
            //$.SearchJob();
        });
    };

    $.clearFilters = function () {
        var search_keyword = $("#search_keyword").val();
        var search_location_2 = decodeURIComponent($("#search_location_2").val());
        $("#search_location").val('');
        $("#search_category").val('');
        $("#filter_job_type").val('');
        $("#search_salary").val('');
        $("#search_education").val('');
        $("#search_type").val('');
        $("#search_salary").val('');
        var qPage = 'q=' + search_keyword + "&loc=" + encodeURIComponent(search_location_2);
        window.location.hash = qPage;
        localStorage.setItem('qPage', qPage);
        for (var member in guided_search_stuff.active_filters)
            delete guided_search_stuff.active_filters[member];
        $.updateFilters();
    };

    $.updateFilters = function () {
        $('#guided-search-filters').parent().addClass('load');
        $('.spinner-load').show();
        var search_keyword = decodeURIComponent($("#search_keyword").val());
        //var search_location = decodeURIComponent($("#search_location").val());
        //var search_location_2 = decodeURIComponent($("#search_location_2").val());
        var search_location = decodeURIComponent($("#search_location_2").val());
        var search_location_2 = "";
        var search_education = decodeURIComponent($("#search_education").val());
        var search_type = decodeURIComponent($("#search_type").val());
        var search_salary = decodeURIComponent($("#search_salary").val());
        var sort_by = $("#sort_type").val();
        var orderby = $("#sort_order").val();
        if (search_keyword === '') {
            //update filters thing
            //now we allow users to filter without searching
            /*$.setUpFilters({filters:[]});
             if(search_location == '0' || search_location == '') {
             //hide the filter button
             $('#add-filter').remove();
             }
             return;*/
            //uncoment this: search_keyword = '*';
        }

        var jsonData = {
            keyword: (search_keyword === '' ? '*' : search_keyword),
            company_id: 0,
            search_location: search_location,
            search_location_2: search_location_2,
            search_education: search_education,
            search_type: search_type,
            search_salary: search_salary,
            search_category: '',
            filter_job_type: '',
            filter_salary: 0,
            sort_by: sort_by,
            orderby: orderby,
            start: 0,
            get_filters_only: 'yes',
            noOfRecords: 0, //we dont want job, only filters
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "GET"
        };
        var request = $.ajax({
            url: canvas_url + "api/job/list",
            data: jsonData,
            type: 'GET',
            crossDomain: true,
            dataType: 'json'
        });
        request.done(function (data) {
            //reset everything
            $('#guided-search-filters').parent().removeClass('load');
            $('.spinner-load').hide();
            //$("#search_location").val('0');
            $("#search_education").val('');
            $("#search_type").val('');
            $("#search_salary").val('');
            //apply the correct filters

            $.each(guided_search_stuff.active_filters, function (k, v) {
                //set values for the search
                if (v.type === 'regions')
                    $("#search_location").val(v.label);
                else if (v.type === 'education')
                    $("#search_education").val(v.label);
                else if (v.type === 'jobType')
                    $("#search_type").val(v.label);
                else if (v.type === 'salary')
                    $("#search_salary").val(v.label);
            });
            $.setUpFilters({filters: data.filters});
            if ($('#guided-search-filters').children().length == 0 && $('#search-filter-modal').is(':visible') === true)
                $('#update-filters').trigger('click');
        });
    };

    $.setUpFilters = function (params) {
        var guided_search = {};
        var root = $('#guided-search-filters');
        var html = '';
        var parent = 0;
        $.each(params.filters, function (k, v) {
            var label = '';
            if (k === 'regions')
                label = txt_job_loc + ' <i class="mdi mdi-map-marker"></i>';
            else if (k === 'education')
                label = min_education + ' <i class="mdi mdi-school"></i>';
            else if (k === 'jobType')
                label = txt_job_type + ' <i class="mdi mdi-checkbox-marked-circle-outline"></i>';
            else if (k === 'salary')
                label = txt_salary + ' <i class="mdi mdi-cash-usd"></i>';
            else
                label = k.charAt(0).toUpperCase() + k.slice(1);
            html += '<div class="form-group"><p>' + label + '</p><ul class="filter-tag available-filters">';
            for (var i = 0; i < v.length; i++) {
                if (k === 'salary') {
                    //if(v[i].label != '10001.0-*')
                    v[i].label = v[i].label.replace(/(\.0)/g, '');
                    //else
                    //    v[i].label = 'Above 10000';
                }

                //find out if this filter is active (when refreshing the page)
                var is_active = false;
                //if($('.search-filter > .filter-tag').children().length == 0) {
                $.each(guided_search_stuff.active_filters, function (filter_k, filter_v) {
                    if (filter_v.label === v[i].label)
                        is_active = true;
                });
                //} else {
                //    $.each(guided_search_stuff.active_filters, function(filter_k, filter_v) {
                //        if(filter_v.label == v[i].label) is_active = true;
                //    });
                //}
                if (is_active === true) {
                    html += '<li class="remove-filter active" data-child="' + i + '" data-parent="' + parent + '" data-type="' + k + '"><span class="filter-label">' + v[i].label + '</span> <span class="filter-count">(' + v[i].count + ')</span></li>';
                } else {
                    if (guided_search_stuff.active_filters['parent_' + parent] === undefined && v[i].count > 0)
                        html += '<li class="add-filter" data-child="' + i + '" data-parent="' + parent + '" data-type="' + k + '"><span class="filter-label">' + v[i].label + '</span> <span class="filter-count">(' + v[i].count + ')</span></li>';
                }
            }
            html += '</ul></div>';
            parent++;
        });
        if (html !== '')
            root.html(html);
        $(".search-filter > .filter-tag").html('');
        //if(guided_search_stuff.fresh == true) {
        $.each(guided_search_stuff.active_filters, function (k, v) {
            var tag = '<li class="active">' +
                    v.label + ' <span class="hide">(' + v.count +
                    ')</span><a class="close remove-filter" data-target="' + i + '" data-parent="' + k.replace(/\D/g, '') +
                    '" data-child="' + v.child + '" data-type="' + v.type + '"><i class="mdi mdi-close"></i></a></li>';
            $(".search-filter > .filter-tag").append(tag);
        });
        //}

        if ($('.search-filter > .filter-tag').children().length > 0 && $('#search-filter-modal').is(':visible') === false)
            $(".search-filter").show();
        else
            $(".search-filter").hide();
        //guided_search_stuff.fresh = false;
        //console.log(params);

    };
    /*
     **************************************** End Guided Search (filters) ****************************************
     */

    // $('.change-contact-close').click(function(e){e.preventDefault();$('#change-contact-box').fadeOut('fast');$('#change-contact-bg').fadeOut('fast');});
    $('.videos-thumb').click(function () {
        var src = $(this).attr('data-video-src');
        document.getElementById('vid-iframe').src = src;
        $('#video-modal').modal();
        ga('send', 'event', 'videos', 'watch', src);
    });
    $('#video-modal').on('hidden.bs.modal', function () {
        ga('send', 'event', 'videos', 'close', document.getElementById('vid-iframe').src);
        document.getElementById('vid-iframe').src = '';
    });


    $.viewImpressionsTracking = function (type, jobId, source){

        var jsonData = {
            type: type,
            jobId: jobId,
            source: source,
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "POST"
        };

        var request = $.ajax({
            url: "/api/jobs/views",
            data: jsonData,
            type: 'POST',
            crossDomain:true,
            dataType:'json'
        });

        request.done(function(data){

        });

        request.fail(function(e){
            console.log(e)
        });


    };

    $.viewImpressionsBulkTracking = function (type, jobId, source){

        var jsonData = {
            type: type,
            jobId: jobId, // array
            source: source,
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "POST"
        };

        var request = $.ajax({
            url: "/api/jobs/views/bulk",
            data: jsonData,
            type: 'POST',
            crossDomain:true,
            dataType:'json'
        });

        request.done(function(data){

        });

        request.fail(function(e){
            console.log(e)
        });


    };

    $.getBanner();
    $.getBannerV3('weblite_desktop');
    $.getBannerV3('weblite_mobile');

});
// END OF DOCUMENT READY

$.getBanner = function() {
    //-------- BANNER ---------//
    var request = $.ajax({
        url: canvas_url+"api/banners",
        dataType: 'json',
        type: 'GET'
    });

    request.done(function (data) {

        if (data.success == true) {

            var banner = $.map(data.data, function(value, index) {
                return [value];
            });

            // descending
            banner.sort(function(a, b){
                return a.id + b.id;
            });

            var template = '';
            var status = '';
            var post_detail = '';

            for (var i = 0; i < banner.length; i++) {

                if (banner[i].status == 'active') {
                    status = '';
                }else{
                    status = 'hide'
                }


                template = '<div class="banner-carousel w-100p xs-mb-0 banner-slick">\
                                    <a v-for="banner in banners" href="'+ banner[i].url + '" target="_blank" class="dashboardpromoclick d-block" " >\
                                        <img  src="' + banner[i].file + '" alt="' + banner[i].alternate + '" class="center-block lazy w-100p baner height-img xs-m-10"/>\
                                    </a>\
                                </div>\
                            </div>';
                post_detail = '<div class="banner-carousel w-100p xs-mb-0 banner-slick">\
                                <span style="font-size:20px">\
                                <strong>\
                                <a href="'+ banner[i].url + '" onclick="ga("send", "event", "banner", "view", \'' + banner[i].alternate + '\');" target="_blank">\
                                    <img class="slide_detail" alt="' + banner[i].alternate + '" src="' + banner[i].file + '" style="height:160px; width:500px;">\
                                        </a>\
                                    </strong>\
                                </span>\
                                </div>';


                $('#promo_banner').append(template);
                $('#promo_banner_detail').append(post_detail);
            }


            //init promo banner
            $('#promo_banner').slick({
                appendArrows: $('#promo_action'),
                prevArrow: '<a class="promo-action-left left"><i class="glyphicon glyphicon-chevron-left" style="width: 7.4px;margin-left: -20px;height: 12px;font-size: 20px;color:#25A67F;left: 9px;top: -63px;"></i></a>',
                nextArrow:'<a class="promo-action-right right"> <i class="glyphicon glyphicon-chevron-right" style="width: 7.4px;height: 12px;font-size: 20px;color:#25A67F;  left: 5px;left: -10px;top: -63px;"></i></a>',
                accessibility: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                infinite: true,speed: 500,
                fade: true,
                cssEase: 'linear'
            });

            $('#promo_banner_detail').slick({
                appendArrows: $('#promo-action-detail'),
                prevArrow: '<a class="promo-action-left left"><i class="glyphicon glyphicon-chevron-left nav-left"></i></a>',
                nextArrow:'<a class="promo-action-right right"> <i class="glyphicon glyphicon-chevron-right nav-right"></i></a>',
                accessibility: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                infinite: true,speed: 500,
                fade: true,
                cssEase: 'linear'
            });


            //check if promo empty then hide
            if($('#promo_banner > .slick-list > .slick-track').children().length < 1){
                $('#promo_banner').parent().hide();
            }else{
                $('#promo_banner').parent().show();
            }

            if($('#promo_banner_detail > .slick-list > .slick-track').children().length < 1){
                $('#promo_banner_detail').parent().hide();
            }else{
                $('#promo_banner_detail').parent().show();
            }


        }else{
            console.log('no banner');
        }
    });
}

$.getBannerV3 = function(client) {
    //-------- BANNER ---------//
    var request = $.ajax({
        url: canvas_url + "api/bannersv3?client=" + client,
        dataType: 'json',
        type: 'GET'
    });

    function renderTemplate(banner) {
        return '<div class="premium-banner"> \
                    <a href="'+ (banner.linkUrl || '#') +'" target="_blank" onclick="ga(\'send\', \'event\', \'Premium Banner\', \'click\', \''+ banner.id +'\');">\
                        <img class="img-responsive" src="'+ banner.imagePath +'">\
                    </a>\
                </div>';
    }

    request.done(function (data) {
        var isMobile = client === 'weblite_mobile';

        if (data.length > 0) {
            var top = $.grep(data, function(item) {
                return item.placement == 'top';
            })
            var center = $.grep(data, function(item) {
                return item.placement == 'center';
            })
            if (isMobile) {
                if (top.length > 0) {
                    var sliders = "";
                    $.each(top, function(key, value) {
                        sliders += renderTemplate(value)
                    })
                    $('#ad-banner-top-rotation-mobile').html(sliders);
                    $('#ad-banner-top-rotation-mobile').slick({
                        infinite: true,
                        arrows: false,
                        dots: true,
                        // centerMode: true,
                        slidesToShow: 1,
                        adaptiveHeight: true,
                        autoplay: true,
                        autoplaySpeed: 3000,
                    });
                }
                if (center.length > 0) {
                    var sliders = "";
                    $.each(center, function(key, value) {
                        sliders += renderTemplate(value)
                    })
                    $('#ad-banner-center-rotation-mobile').html(sliders);
                    $('#ad-banner-center-rotation-mobile').slick({
                        infinite: true,
                        arrows: false,
                        dots: true,
                        // centerMode: true,
                        slidesToShow: 1,
                        adaptiveHeight: true,
                        autoplay: true,
                        autoplaySpeed: 3000,
                    });
                }
            } else {
                if (top.length > 0) {
                    var sliders = "";
                    $.each(top, function(key, value) {
                        sliders += renderTemplate(value)
                    })
                    $('#ad-banner-top-rotation').html(sliders);
                    $('#ad-banner-top-rotation').slick({
                        infinite: true,
                        arrows: false,
                        dots: true,
                        // centerMode: true,
                        slidesToShow: 1,
                        adaptiveHeight: true,
                        autoplay: true,
                        autoplaySpeed: 3000,
                    });
                }
                if (center.length > 0) {
                    var sliders = "";
                    $.each(center, function(key, value) {
                        sliders += renderTemplate(value)
                    })
                    $('#ad-banner-center-rotation').html(sliders);
                    $('#ad-banner-center-rotation').slick({
                        infinite: true,
                        arrows: false,
                        dots: true,
                        // centerMode: true,
                        slidesToShow: 1,
                        adaptiveHeight: true,
                        autoplay: true,
                        autoplaySpeed: 3000,
                    });
                }
            }
        }
    });
}

function trackEvent(o) {
    var defaults = {
        '_token': $('meta[name="csrf-token"]').attr('content'),
        'event': '',
        'key': '',
        'value': ''
    };
    o = $.extend({}, defaults, o);
    $.post(canvas_url + "api/track-event", o, function (data) {}, "json");
}

$.getJobRecommendation = function (recType, jobId, limit, category, location) {
    var request = $.ajax({
        url: canvas_url + "api/job/newrecommendation",
        type: 'GET',
        crossDomain: true,
        dataType: 'json',
        timeout: 5000
    });
    request.done(function (data) {
        if(data.data) {
            var jobs = data.data;
            $.viewImpressionsBulkTracking('impressions', data.jobIds, 'webblog');
            var appends = "";
            jobs.forEach(function(job, index, arr) {
                appends += '<li>\
                <a target="_blank" class="ah-jobs" rel="nofollow" href="'+ job.url +'">\
                    <img src="'+ job.logo +'" style="display:block!important;" class="logo">\
                    <div class="ah-container">\
                        <div class="ah-job-title">'+ job.jobTitle +'</div>\
                        <div class="ah-desc" style="color: #414141;">'+ job.companyName +'</div>\
                        <div class="ah-desc"><strong style="color: #F26E84;">'+ job.newSalaryLabel +'</strong></div>\
                        <div class="ah-desc text-light">'+ job.region +'</div>\
                    </div>\
                </a>\
                </li>';
            });
            var sectionTitle = $("#new-recommended-jobs").attr("data-section");
            var templateJobs =
            '<div class="right-menu">\
                <div class="ah-widget">\
                    <div class="ah-widget__title">\
                        <h3>'+ sectionTitle +'</h3> \
                    </div>\
                    <ul class="hidden-xs">\
                    '+ appends +'\
                    </ul>\
                </div>\
            </div>';
            $("#new-recommended-jobs").html(templateJobs);
            $("#new-recommended-jobs").show();
        }
    });
    request.fail(function (jqXHR, textStatus) {
        console.log(textStatus);
    });
};

$(document).ready(function() {
    $('.menu-mobile-btn').click(function() {
        // $('ul.menu-dekstop').toggle();
        $('ul.menu-dekstop').toggleClass('active');
    });
});

// Check OS version
function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    }

// Check mobile view or desktop (user agent)
function navigationUserAgent () {
    var isMobile = false;
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
        isMobile = true;
    }
    return isMobile;
}

// Wording Pop Up for MK
function isCategoryBlog(str, platformId) {
    if (platformId == 1 ) {
        var listCategory = [
            {
                zh: '学生专区',
                en: 'Student Sector',
                img: 'Student Sector'
            },
            {
                zh: '生活资讯',
                en: 'Lifestyle',
                img: 'Lifestyle'
            },
            {
                zh: '实用教程',
                en: 'Life Hack',
                img: 'Life Hack'
            },
            {
                zh: '工作秘笈',
                en:'Job Tips',
                img:'Job Tips'
            },
            {
                zh: '时事热点',
                en: 'Trending',
                img: 'Trending'
            }
        ];

        var result = listCategory.find(function(list){
            if (list.zh === str) return list;
            return list.en === str;
        });

        if (result) {
            return result
        }

        return {
            zh: 'Others',
            en: 'Others',
            img: '1_other'
        }
    }

    if (platformId == 2 ) {
        var listCategory = [
            {
                ms: 'Jenis Pekerjaan',
                img: 'Jenis Pekerjaan'
            },
            {
                ms: 'Gaya Hidup',
                img: 'Gaya Hidup'
            },
            {
                ms: 'Pengetahuan Pekerja',
                img: 'Pengetahuan Pekerja'
            },
            {
                ms: 'Pengetahuan Interview',
                img: 'Pengetahuan Interview'
            },
            {
                ms: 'Trending Semasa',
                img: 'Trending Semasa'
            },
            {
                ms: 'Inspirasi & Kerjaya (Mau Sembang)',
                img: 'Inspirasi & Kerjaya (Mausembang)'
            },
            {
                ms: 'Interview Tips Video',
                img: 'Interview Tips Video'
            }
        ];

        var result = listCategory.find(function(list){
            return list.ms === str;
        });

        if (result) {
            return result
        }

        return {
            ms: 'Others',
            img: '2_other'
        }
    }
}

$("#new-search-bar").hide();
$("input.new-search-bar").focus(function() {
    $("#new-search-bar").show();
    $("#search_keyword").focus();
    $(".topnav-search-bar").hide();
    var mq = window.matchMedia("(max-width: 960px)")
    if (mq.matches) {
        $(".navigation-header.search").show();
    }
});
$("#close-search-btn").on('click', function() {
    $("#new-search-bar").hide();
    $(".topnav-search-bar").show();
    var mq = window.matchMedia("(max-width: 960px)")
    if (mq.matches) {
        $(".navigation-header.search").show();
    }
});
